import { map, defaultArg, some } from "../../.fable/fable-library.3.2.6/Option.js";
import { class_type } from "../../.fable/fable-library.3.2.6/Reflection.js";
import Notifications from "../../../src/Services/Notifications/Notifications.css";
import * as react from "react";
import react$002Dnotification$002Dsystem from "react-notification-system";
import { toProps } from "../../Interop/React.fs.js";
import { arrayHash } from "../../.fable/fable-library.3.2.6/Util.js";
import { Prop } from "../../.fable/Fable.React.7.4.1/Fable.React.Props.fs.js";
import { empty, ofArray } from "../../.fable/fable-library.3.2.6/List.js";
import { IconProps, CheckCircleFilled, CloseCircleFilled, ExclamationCircleFilled, InfoCircleFilled } from "../../Interop/Antd/Icon.fs.js";
import { interpolate, toText } from "../../.fable/fable-library.3.2.6/String.js";

export class ConsoleNotifications {
    constructor() {
    }
    Send(level, title, message, _arg1) {
        switch (level) {
            case "info": {
                console.info(some("%s %O"), title, message);
                break;
            }
            case "warning": {
                console.warn(some("%s %O"), title, message);
                break;
            }
            case "error": {
                console.error(some("%s %O"), title, message);
                break;
            }
            default: {
                console.info(some("%s %O"), title, message);
            }
        }
    }
}

export function ConsoleNotifications$reflection() {
    return class_type("Loop54.Portal.WebUI.Services.Notifications.Notifications.ConsoleNotifications", void 0, ConsoleNotifications);
}

export function ConsoleNotifications_$ctor() {
    return new ConsoleNotifications();
}

const styles = Notifications;

function reactNotificationContainer(props, elems) {
    return react.createElement(react$002Dnotification$002Dsystem, toProps(props), ...elems);
}

export class ReactNotifications {
    constructor(system) {
        this.system = system;
        this.consoleNotifications = ConsoleNotifications_$ctor();
    }
    Send(level, title, message, createNotificationContent) {
        const this$ = this;
        this$.consoleNotifications.Send(level, title, message);
        let notificationObj;
        const children = ReactNotifications__createChildren(this$, level, message, defaultArg(createNotificationContent, (s) => s));
        notificationObj = {
            autoDismiss: ReactNotifications__duration_5567D638(this$, level),
            children: children,
            dismissible: "button",
            level: level,
            title: title,
            uid: arrayHash([level, title, message]),
        };
        this$.system.addNotification(notificationObj);
    }
}

export function ReactNotifications$reflection() {
    return class_type("Loop54.Portal.WebUI.Services.Notifications.Notifications.ReactNotifications", void 0, ReactNotifications);
}

export function ReactNotifications_$ctor_Z5966C024(system) {
    return new ReactNotifications(system);
}

export function ReactNotifications_Container_Z5B87BE00(ref) {
    return react.createElement("div", {
        className: styles.notificationSystem,
    }, reactNotificationContainer(ofArray([new Prop(3, ref), ["style", false]]), empty()));
}

function ReactNotifications__duration_5567D638(this$, level) {
    switch (level) {
        case "info": {
            return 5;
        }
        case "warning":
        case "error": {
            return 0;
        }
        default: {
            return 5;
        }
    }
}

function ReactNotifications__createChildren(this$, level, message, createNotificationContent) {
    return [((level === "info") ? ((props_1) => ((elems_1) => InfoCircleFilled(props_1, elems_1))) : ((level === "warning") ? ((props_2) => ((elems_2) => ExclamationCircleFilled(props_2, elems_2))) : ((level === "error") ? ((props_3) => ((elems_3) => CloseCircleFilled(props_3, elems_3))) : ((props) => ((elems) => CheckCircleFilled(props, elems))))))(ofArray([new IconProps(0, toText(interpolate("%P()", [styles.notificationIcon]))), new IconProps(6, "icon")]))(empty()), react.createElement("div", {
        className: styles.notificationContent,
        key: "message",
    }, createNotificationContent(message))];
}

export const Context = react.createContext(ConsoleNotifications_$ctor());

export function get$(container) {
    return defaultArg(map((element) => ReactNotifications_$ctor_Z5966C024(element), container), ConsoleNotifications_$ctor());
}

